import ModeEditOutlineOutlinedIcon from "@mui/icons-material/ModeEditOutlineOutlined";
import { useTranslation } from "react-i18next";
import { Link as RouterLink } from "react-router-dom";
import { ProductType } from "../../shared/enums/ProductType";
import { Product, productHelper } from "../../shared/helpers/productHelper";
import { ProductItem } from "../../shared/types/ProductItem";
import ProductImage from "../shared/ProductImage";
import "./CartItem.scss";
import { getImageUrl } from "../../shared/helpers/getImageUrl";

interface CartItemProps {
  configLink: string;
  market: string;
  product: Product | ProductItem;
  productType?: ProductType;
}

const CartItem = ({
  configLink,
  market,
  product,
  productType,
}: CartItemProps) => {
  const { t } = useTranslation([
    "cart",
    "machinefixings",
    "tiltrotator",
    "tools",
  ]);
  const productData = productHelper.getCartProductData({
    market,
    product,
    productType,
    t,
  });

  if (!productData) {
    return <></>;
  }

  return (
    <div className="cartItemContainer">
      <div className="cartItem cartItemNameContainer">
        <div className="cartItemName">
          <div>
            <ProductImage
              alt=""
              height={40}
              width={40}
              localSrc={getImageUrl(productData)}
          />
          </div>
          <div className="cartItemHeaderName">
            <div className="cartItemLabel">{productData.nameLabel}</div>
            <div className="cartItemText">{productData.name}</div>
          </div>
        </div>
        <RouterLink to={configLink}>
          <button className="listItemButtonConfig">
            <ModeEditOutlineOutlinedIcon />
          </button>
        </RouterLink>
      </div>
      {productData.rows.map((row, index) => {
        return (
          <div key={`row${index}`}>
            <div className="cartItem">
              <div className="cartItemCol cartItemColLeft">
                <div className="cartItemLabel">{row.leftColumn.label}</div>
                <div className="cartItemText">{row.leftColumn.text}</div>
              </div>
              {row.rightColumn && (
                <div className="cartItemCol cartItemColRight">
                  <div className="cartItemLabel">{row.rightColumn?.label}</div>
                  <div className="cartItemText">{row.rightColumn?.text}</div>
                </div>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default CartItem;
